import React from "react";
import { Collapse, Typography, makeStyles, Box } from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Number from "../../../../custom/Number";

const useStyles = makeStyles((theme) => ({
  container: {
    margin: theme.spacing(2, 0, 1),
    paddingBottom: theme.spacing(1),
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  header: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    cursor: "pointer",
  },
  collapseDisabled: {
    cursor: "auto",
  },
  headerLeft: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(0.5),
    flexShrink: 1,
  },
  title: {
    wordBreak: "break-word",
    flexShrink: 1,
  },
  icon: {
    transition: "transform 0.2s ease",
    marginLeft: theme.spacing(0.5),
    transform: "rotate(180deg)",
  },
  iconOpen: {
    transform: "rotate(0deg)",
  },
  total: {
    display: "flex",
    alignItems: "center",
    whiteSpace: "nowrap",
  },
  content: {
    marginTop: theme.spacing(1),
  },
}));

const InfoCollapseSection = ({ title, total, children, enableCollapse, showTotal }) => {
  const classes = useStyles();
  const [open, setOpen] = React.useState(true);

  const handleToggleCollapse = () => {
    if (enableCollapse) {
      setOpen((prev) => !prev);
    }
  };

  return (
    <Box className={classes.container}>
      <Box
        className={`${classes.header} ${enableCollapse ? "" : classes.collapseDisabled}`}
        onClick={handleToggleCollapse}
      >
        <Box className={classes.headerLeft}>
          <Typography
            className={classes.title}
            variant="body1"
            color="textPrimary"
          >
            {title}
          </Typography>
          {enableCollapse && <ExpandMoreIcon className={`${classes.icon} ${open ? classes.iconOpen : ""}`} />}
        </Box>

        {showTotal && (
          <Box className={classes.total}>
            <Typography
              variant="body1"
              color="textPrimary"
            >
              <Number
                value={total}
                currency="LCT"
              />
            </Typography>
          </Box>
        )}
      </Box>

      <Collapse in={open}>
        <Box className={classes.content}>{children}</Box>
      </Collapse>
    </Box>
  );
};

export default InfoCollapseSection;
